import { render, staticRenderFns } from "./EModalBoletimFranquia.vue?vue&type=template&id=112a939e&scoped=true"
import script from "./EModalBoletimFranquia.vue?vue&type=script&lang=js"
export * from "./EModalBoletimFranquia.vue?vue&type=script&lang=js"
import style0 from "./EModalBoletimFranquia.vue?vue&type=style&index=0&id=112a939e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112a939e",
  null
  
)

export default component.exports